<template>
  <div class="app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-form
          label-position="right"
          :model="listQuery"
          label-suffix="："
          label-width="auto"
        >
          <el-row :gutter="10" type="flex" justify="start" align="middle">
            <el-col :span="6">
              <el-form-item :label="$t('public.licensePlate')">
                <el-input
                  v-model="listQuery.licensePlate"
                  filterable
                  clearable
                  :placeholder="$t('public.licensePlate')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('public.obdCode')">
                <el-input
                  v-model="listQuery.barCode"
                  filterable
                  clearable
                  :placeholder="$t('public.obdCode')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('vehicleAlarm.overspeedRecord.alarmTime')"
              >
                <el-row type="flex" justify="start" align="middle">
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.startTime"
                      filterable
                      clearable
                      :placeholder="$t('public.startTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                  &emsp;<span
                    v-show="collapse"
                    class="time-span"
                    style="color: #ddd"
                    >——</span
                  >&emsp;
                  <el-col v-show="collapse" :span="12">
                    <el-date-picker
                      v-model="listQuery.endTime"
                      filterable
                      clearable
                      :placeholder="$t('public.endTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-show="collapse"
            style="margin-top: 10px"
            :gutter="10"
            type="flex"
            justify="start"
            align="middle"
          >
            <el-col v-show="collapse" :span="6">
              <el-form-item
                :label="$t('vehicleAlarm.overspeedRecord.ruleName')"
              >
                <el-input
                  v-model="listQuery.ruleName"
                  filterable
                  clearable
                  :placeholder="$t('vehicleAlarm.overspeedRecord.ruleName')"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <app-search-button
        slot="bottom"
        @click-collapse="handleCollapse"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-filter="showfilter = true"
      @click-export="handleExport"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      ref="table"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{
            scope.$index + 1 + (listQuery.pageNum - 1) * listQuery.pageSize
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
          <div v-if="item.prop === 'licensePlate'">
            <vue-licenseplate
              :types="scope.row['isTempCar']"
              :licensepalte="scope.row[item.prop]"
              :area="scope.row['areaName']"
            />
          </div>
          <div v-else>
            {{ scope.row[item.prop] || "/" }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total > 0 ? 'visible' : 'hidden', 'pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// request
import { overSpeedRecordListUrl, overSpeedRecordExportUrl } from '@/api/vehicleAlarm/overspeedRecord'
// 辅助函数
export default {
  name: 'overspeedRecord',
  components: {},
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle, getPageButton],
  data() {
    return {
      listQuery: {},
      showfilter: false,
      tableList: [
        { value: this.$t('public.licensePlate'), prop: 'licensePlate', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('public.obdCode'), prop: 'barCode', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('vehicleAlarm.overspeedRecord.ruleName'), prop: 'ruleName', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('vehicleAlarm.maxSpeed'), prop: 'maxSpeed', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('public.startTime'), prop: 'startTime', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('public.endTime'), prop: 'endTime', position: 'center', sortable: 'custom', checked: false },
        { value: this.$t('vehicleAlarm.overspeedRecord.startAddress'), prop: 'startAddress', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('vehicleAlarm.overspeedRecord.endAddress'), prop: 'endAddress', position: 'center', sortable: 'custom', checked: false },
        { value: this.$t('vehicleAlarm.overspeedRecord.startSpeed'), prop: 'startSpeed', position: 'center', sortable: 'custom', checked: true },
        { value: this.$t('vehicleAlarm.overspeedRecord.endSpeed'), prop: 'endSpeed', position: 'center', sortable: 'custom', checked: false },

      ],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  methods: {
    // 加载数据
    listLoad() {
      const startTime = new Date(this.listQuery.startTime).getTime()
      const endTime = new Date(this.listQuery.endTime).getTime()
      if (startTime > endTime) {
        this.$message.error({
          message: this.$t('public.timeError'),
          duration: 2 * 1000
        })
        return
      }
      this.listLoading = true
      this.$http.post(overSpeedRecordListUrl, this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    // 导出
    handleExport() {
      this.$http.post(overSpeedRecordExportUrl, this.listQuery, {
        responseType: 'arraybuffer'
      })
    }
  }
}
</script>
